import React from "react";
import SecondStepRoom from "./SecondStepRoom";
import { Button, Select } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import RowForm from "./RowForm";

function SecondStep({ state, setState }) {
  const { t } = useTranslation("common");
  return (
    <div
      className="my-10 backdrop-blur-lg w-full h-full 
  rounded-lg py-10 border border-dashed border-gray-500
  px-5 md:px-20 gap-5 flex flex-col"
    >
      <div className="!py-2 w-full flex justify-end">
        <RowForm
              label={t("request.step2.treatment")}
              input={
                <Select
                  style={{
                    width: "100%",
                  }}
                      value={state.rooms[0].treatment}
                  onChange={(e) =>
                    setState({
                      ...state,
                      rooms: state.rooms.map((rm) => {
                          if (rm.id === state.rooms[0].id) state.rooms[0].treatment = e;
                        return rm;
                      }),
                    })
                  }
                  options={[
                    {
                      value: "ALLIN",
                      label: "All Inclusive",
                    },
                    {
                      value: "B&B",
                      label: "B&B",
                    },
                    {
                      value: "HALF",
                      label: t("request.step2.treatmentHalf"),
                    },
                    {
                      value: "FULL",
                      label: t("request.step2.treatmentFull"),
                    },
                    {
                      value: "BED",
                      label: t("request.step2.treatmentBooking"),
                    },
                  ]}
                />
              }
            />
        <Button
          type="dashed"
          className="text-white"
          onClick={() =>
            setState({
              ...state,
              rooms: [
                ...state.rooms,
                {
                  id: state.rooms.length + 1,
                  dates: [dayjs(), dayjs().add(2, "day")],
                  treatment: "ALLIN",
                  adults: 1,
                  children: 0,
                },
              ],
            })
          }
        >
          {t("request.step2.addRoom")}
        </Button>
      </div>
      {state.rooms?.map((room, index) => (
        <SecondStepRoom
          room={room}
          state={state}
          setState={setState}
          key={"room-" + index}
          index={index}
        />
      ))}
    </div>
  );
}

export default SecondStep;
